import React from "react";
import { useTranslation } from "react-i18next";

function Impressum() {
  const { t } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" id="impressum">
      {/* Header Section */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
          {t("impressum.title")}
        </h1>
      </div>

      <div className="space-y-6">
        {/* Vereinsinformationen */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-4 pb-2 border-b border-slate-200 dark:border-slate-700">
            {t("impressum.organization.name")}
          </h2>
          <div className="space-y-3">
            <div>
              <h3 className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                {t("impressum.organization.address.title")}
              </h3>
              <p className="text-slate-600 dark:text-slate-400">
                {t("impressum.organization.address.line1")}
              </p>
              <p className="text-slate-600 dark:text-slate-400">
                {t("impressum.organization.address.line2")}
              </p>
            </div>
          </div>
        </div>

        {/* Vereinsregistrierung */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-4 pb-2 border-b border-slate-200 dark:border-slate-700">
            {t("impressum.registration.title", "Registrierung")}
          </h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                {t("impressum.registration.number.title")}
              </h3>
              <p className="text-slate-600 dark:text-slate-400">
                {t("impressum.registration.number.value")}
              </p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                {t("impressum.registration.tax.title")}
              </h3>
              <p className="text-slate-600 dark:text-slate-400">
                {t("impressum.registration.tax.value")}
              </p>
            </div>
          </div>
        </div>

        {/* Satzung */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-4 pb-2 border-b border-slate-200 dark:border-slate-700">
            {t("impressum.statutes.title")}
          </h2>
          <a
            href="/documents/Satzung-GCWAA-2.pdf"
            download="GCWAA-Satzung.pdf"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-primary dark:bg-primary-light text-white text-sm font-medium rounded-md hover:bg-primary-dark dark:hover:bg-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary/20"
          >
            <i className="fas fa-download text-xs"></i>
            {t("impressum.statutes.linkText")}
          </a>
        </div>

        {/* Vorstand */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-4 pb-2 border-b border-slate-200 dark:border-slate-700">
            {t("impressum.board.title")}
          </h2>
          <div className="space-y-2">
            <p className="text-slate-600 dark:text-slate-400">
              {t("impressum.board.president")}
            </p>
            <p className="text-slate-600 dark:text-slate-400">
              {t("impressum.board.vicePresident")}
            </p>
          </div>
        </div>

        {/* Haftungsausschluss */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-4 pb-2 border-b border-slate-200 dark:border-slate-700">
            {t("impressum.disclaimer.title")}
          </h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                {t("impressum.disclaimer.content.title")}
              </h3>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                {t("impressum.disclaimer.content.text")}
              </p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                {t("impressum.disclaimer.links.title")}
              </h3>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                {t("impressum.disclaimer.links.text")}
              </p>
            </div>
          </div>
        </div>

        {/* Urheberrecht */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-4 pb-2 border-b border-slate-200 dark:border-slate-700">
            {t("impressum.copyright.title")}
          </h2>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            {t("impressum.copyright.text")}
          </p>
        </div>

        {/* Datenschutz */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-4 pb-2 border-b border-slate-200 dark:border-slate-700">
            {t("impressum.privacy.title")}
          </h2>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            {t("impressum.privacy.text")}
          </p>
        </div>

        {/* Rechtswirksamkeit */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-4 pb-2 border-b border-slate-200 dark:border-slate-700">
            {t("impressum.legalValidity.title")}
          </h2>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            {t("impressum.legalValidity.text")}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Impressum;
